/**
 * @desc intercept
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.outPlanFacadeImpl.intercept.Params, options?: any) {
  return updateResponse(
    http(URL + `/outPlan/intercept`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
